<ng-container *ngIf="displayAlert()">
  <div class="alert-danger">
    <div class="p-375">
      <span class="me-2"><i class="fa fa-bell"></i></span> License Alert !
    </div>
  </div>
</ng-container>
<ng-container *ngIf="displayWarning()">
  <div class="alert-warning">
    <div class="p-375">
      <span class="me-2"><i class="fa fa-bell"></i></span> License Warning !
    </div>
  </div>
</ng-container>
